<template>
  <div class="dictionary clearfix">
    <div class="dictionary-left">
      <el-row class="dictionary-row">
        <el-col :span="9">
          <span class="dictionary-row-span-ml">
            <img src="@/assets/beadhouse/juxing.png" alt style="vertical-align:middle;" />
          </span>
          <span style="height:54px;line-height:54px;font-size:16px;color:#6F7075;">角色权限</span>
        </el-col>
        <el-col :span="3" :offset="12">
          <span style="height:54px;line-height:54px;">
            <img src="@/assets/beadhouse/bigjia.png" alt="" class="vertical-align-cursor" @click="addRoleAuthority">
          </span>
        </el-col>
      </el-row>
      <el-row style="width:90%;margin:10px auto;">
        <el-tree :data="treeList" node-key="id" :default-expand-all="false" :expand-on-click-node="false"
          @node-click="handleNodeDictionary" :props="defaultProps">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span>
              <el-button type="text" size="mini" @click="() => appendRole(data)">
                <img src="@/assets/beadhouse/bigjia.png" alt class="vertical-align-cursor" />
              </el-button>
              <el-button type="text" size="mini" @click="() => editRole(data)">
                <img src="@/assets/beadhouse/bianji_icon.png" alt class="vertical-align-cursor" />
              </el-button>
              <el-button type="text" size="mini" @click="() => removeRole(node, data)">
                <img src="@/assets/beadhouse/shanchu_icon.png" alt class="vertical-align-cursor" />
              </el-button>
            </span>
          </span>
        </el-tree>
      </el-row>
    </div>
    <div class="dictionary-right">
      <el-row>
        <el-row class="dictionary-row">
          <el-col :span="0">
            <!-- <span class="dictionary-row-span-ml"><img src="@/assets/beadhouse/juxing.png" alt="" style="vertical-align:middle;"></span> -->
          </el-col>
          <el-col :span="15" style="font-size:16px;">
            <span class="dictionary-row-span-ml">
              <img src="@/assets/beadhouse/juxing.png" alt style="vertical-align:middle;" />
            </span>
            <span style="color:#6F7075;">基本信息</span>
          </el-col>
          <el-col :span="2" :offset="7" align="center"></el-col>
        </el-row>
      </el-row>
      <el-row v-if="list.length != 0">
        <el-row v-for="(item, index) in list" :key="index">
          <el-row>
            <el-row class="height60" style="color:#6F7075;">
              <el-col :span="23" :offset="1">
                <span>角色权限：</span>
                <span>{{ item.title }}</span>
              </el-col>
            </el-row>
            <el-row class="height60" style="color:#6F7075;margin-bottom:30px;">
              <el-col :span="23" :offset="1">
                <span>角色描述：</span>
                <span>{{ item.text }}</span>
              </el-col>
            </el-row>
          </el-row>
        </el-row>
      </el-row>
      <el-row v-else>
        <el-row>
          <el-row class="height60" style="color:#6F7075;">
            <el-col :span="23" :offset="1">
              <span>角色权限：</span>
              <span>暂无数据</span>
            </el-col>
          </el-row>
          <el-row class="height60" style="color:#6F7075;margin-bottom:30px;">
            <el-col :span="23" :offset="1">
              <span>角色描述：</span>
              <span>暂无数据</span>
            </el-col>
          </el-row>
        </el-row>
      </el-row>
      <el-row>
        <el-row class="dictionary-row">
          <el-col :span="0">
            <!-- <span class="dictionary-row-span-ml"><img src="@/assets/beadhouse/juxing.png" alt="" style="vertical-align:middle;"></span> -->
          </el-col>
          <el-col :span="15" style="font-size:16px;">
            <span class="dictionary-row-span-ml">
              <img src="@/assets/beadhouse/juxing.png" alt style="vertical-align:middle;" />
            </span>
            <span style="color:#6F7075;">设备角色权限表</span>
          </el-col>
          <el-col :span="2" :offset="7" align="center">
            <span class="dictionary-row-span-ml">

            </span>
          </el-col>
        </el-row>
      </el-row>
      <el-row style="margin-top:10px;">
        <!--表格内容栏-->
        <el-table :border="false" :data="tableData" :row-style="tableRowStyle" :header-cell-style="tableHeaderColor"
          style="width: 100%">
          <el-table-column prop="deviceNo" label="设备编号" min-width="120" align="center"></el-table-column>
          <el-table-column prop="deviceName" label="设备名称" min-width="100" align="center"></el-table-column>
          <el-table-column prop="roleName" label="角色名称" min-width="100" align="center">
            <template slot-scope="scope">
              <span style="margin-left: 10px;color:orange;" v-if="scope.row.roleName == null">--</span>
              <span style="margin-left: 10px" v-else>{{ scope.row.roleName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="roleCode" label="角色编码" min-width="100" align="center">
            <template slot-scope="scope">
              <span style="margin-left: 10px;color:orange;" v-if="scope.row.roleCode == null">--</span>
              <span style="margin-left: 10px" v-else>{{ scope.row.roleCode }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="door" label="是否开门" min-width="100" align="center">
            <template slot-scope="scope">
              <span style="margin-left: 10px;color:red;" v-if="scope.row.door == 0">关</span>
              <span style="margin-left: 10px;color:green;" v-else>开</span>
            </template>
          </el-table-column>
          <el-table-column prop="roleRemark" label="角色权限描述" min-width="200" align="center">
            <template slot-scope="scope">
              <span style="margin-left: 10px;color:orange;" v-if="scope.row.roleRemark == null">--</span>
              <span style="margin-left: 10px" v-else>{{ scope.row.roleRemark }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="oldmanName" label="持卡人姓名" min-width="120" align="center">
            <template slot-scope="scope">
              <span style="margin-left: 10px;color:orange;" v-if="scope.row.oldmanName == null">--</span>
              <span style="margin-left: 10px" v-else>{{ scope.row.oldmanName }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" layout="total, prev, pager, next" :total="totalDataNumber" :page-size="pageSize"
          align="center" class="fenye">
        </el-pagination>
      </el-row>
    </div>
    <!-- 新增角色权限和修改角色曲线的dialog模态框-->
    <el-dialog :title="operation ? '新增角色权限' : '修改角色权限'" width="35%" :visible.sync="dialogVisibleForm"
      :close-on-click-modal="false" @close="closeDictionaryDialog">
      <el-form :model="dataForm" label-width="120px" :rules="dataFormRules" ref="dataForm" label-position="right">
        <el-form-item label="角色名称:" prop="roleName">
          <el-input v-model.trim="dataForm.roleName" auto-complete="off" placeholder="请输入角色名称"
            style="width:80%;"></el-input>
        </el-form-item>
        <el-form-item label="角色编码:" prop="roleCode">
          <el-row style="height:40px;line-height:40px;">
            <el-radio-group v-model="dataForm.roleCode" placeholder="请选择角色编码">
              <el-radio label="oldman">老人</el-radio>
              <el-radio label="emp">员工</el-radio>
              <el-radio label="other">其他</el-radio>
            </el-radio-group>
          </el-row>
        </el-form-item>
        <el-form-item label="是否开门:" prop="door">
          <el-row style="height:40px;line-height:40px;">
            <el-radio-group v-model="dataForm.door" placeholder="请选择是否开门">
              <el-radio :label="1">开</el-radio>
              <el-radio :label="0">关</el-radio>
            </el-radio-group>
          </el-row>
        </el-form-item>
        <el-form-item label="描述:" prop="remark">
          <el-input v-model.trim="dataForm.remark" type="textarea" :rows=4 auto-complete="off" placeholder="请输入描述"
            style="width:80%;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="dialogVisibleForm = false">取消</el-button>
        <el-button :size="size" type="primary" @click.native="submitForm"
          :loading="dataFormLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import KtTable from "@/components/KtTable";
import KtButton from "@/components/KtButton";
export default {
  name: "Dictionary",
  components: { KtTable, KtButton },
  data() {
    return {
      dialogVisibleForm: false,
      dataFormLoading: false,
      list: [],//基本信息的数据源
      operation: true, //默认是true  点击dialog显示的是新字典的dialog模态框
      size: "medium", //按钮的尺寸
      dictionary: {
        dataDictionary: "数据字典",
        dictionaryManagement: "字典管理",
        newDataDictionary: "新增数据字典",
        editDataDictionary: "修改数据字典",
        deleteDataDictionary: "删除数据字典",
        dictionaryTypeName: "字典类型名称",
        dictionaryTypeCode: "字典类型编码",
        dictionaryItemName: "字典项名称",
        dictionaryValue: "字典项值",
        dictionaryType: "类型",
        dictionaryTypeDescription: "字典类型描述",
        pleaseEnterDictionaryTypeName: "请输入字典类型名称",
        pleaseEnterDictionaryTypeCode: "请输入字典类型编码",
        pleaseEnterDictionaryItemName: "请输入字典项名称",
        pleaseEnterDictionaryValue: "请输入字典项值",
        pleaseEnterDictionaryTypeDescription: "请输入字典类型描述",
        pleaseEnterDictionaryType: "请选择类型",
        notEmpty: "不能为空",
        loading: "加载中...",
        constant: "常量",
        folder: "文件夹"
      }, //引入 lang 里面的字符串资源
      id: "", //当前菜单的id  默认显示第一个tree的菜单
      pid: "", //父级的id
      treeList: [], //tree树
      defaultProps: {
        children: "children",
        label: "roleName"
      },
      //新增和修改字典的dialog模态框的配置

      dataForm: {
        roleCode: "oldman",//oldamn---老人    emp---员工     other----其他
        door: 1,//1----开   0----关
        roleName: "",
        remark: "",
      }, //新增字典数据源
      dataFormRules: {
        //验证的匹配规则
        roleName: [
          {
            required: true,
            message: "角色名称不能为空",
            trigger: "blur"
          },
          { min: 1, max: 15, message: '长度在 1到 15 个字符' },
        ],
        roleCode: [
          {
            required: true,
            message: "角色编码不能为空",
            trigger: "change"
          }
        ],
        door: [
          {
            required: true,
            message: "是否开门不能为空",
            trigger: "change"
          }
        ],
        remark: [
          {
            required: true,
            message: "描述不能为空",
            trigger: "blur"
          },
          { min: 1, max: 30, message: '长度在 1到 30 个字符' },
        ]
      },
      loading: false, //表格加载的loading
      tableData: [],
      /* 分页的 */
      currentPage: 1, //初始页
      pageNum: 1,//页码
      pageSize: 5,//每页显示的条数
      totalDataNumber: 8,//数据的总数,
    };
  },
  methods: {
    /*  
      新增角色权限   顶层添加
    */
    addRoleAuthority() {
      this.pid = 0;//将pid初始化
      this.dialogVisibleForm = true;
      this.dataForm = {
        roleCode: "oldman",//oldamn---老人    emp---员工     other----其他
        door: 1,//1----开  0----关
        roleName: "",
        remark: "",
      };
    },

    /* 
        关闭新增和修改字典的dialog
    */
    closeDictionaryDialog() {
      this.$nextTick(() => {
        if (this.$refs.dataForm != undefined) {
          this.$refs.dataForm.resetFields(); //移除校验结果并重置字段值
        }
      });
    },

    /* 
      点击tree树
    */
    handleNodeDictionary(data, node, vuecomponent) {
      console.log(data, node, vuecomponent);
      this.list = [];//每次点击之前先清空数据
      this.id = data.id;
      this.list.push({ id: data.id, title: data.roleName, text: data.remark });
      this.queryListWithPage();
    },

    /* 
      新增角色权限  在tree树上面添加
    */
    appendRole(data) {
      console.log(data);
      this.pid = data.id;//获取点击的该tree菜单的id   该id实际上为新增tree菜单的pid   
      console.log(this.pid);
      this.operation = true; //true 新增的
      this.dialogVisibleForm = true; //dialog模态框打开
      this.dataForm = {
        roleCode: "oldman",//oldamn---老人    emp---员工     other----其他
        door: 1,//1----开  0----关
        roleName: "",
        remark: "",
      };
    },

    /* 
      修改字典 弹出dialog模态框
    */
    editRole(data) {
      console.log(data);
      this.id = data.id;//获取当前点击的tree菜单的id
      this.pid = data.pid;//获取当前点击的tree菜单的pid
      console.log(this.id, this.pid);
      this.operation = false; //修改的
      this.dialogVisibleForm = true; //dialog模态框打开
      this.dataForm.roleName = data.roleName;
      this.dataForm.roleCode = data.roleCode;
      this.dataForm.door = data.door;
      this.dataForm.remark = data.remark;
      console.log(this.dataForm);
    },

    /* 
        新增 和  修改 字典提交数据
    */
    submitForm() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          let params = {};
          params = Object.assign({}, this.dataForm); //拷贝需要提交的数据源
          console.log(this.operation);
          var url = "";
          if (this.operation == false) {//修改
            //修改的时候需要传id
            params.id = this.id;
            params.pid = this.pid;
            url = "dmc/rfidLabelRole/edit"
          } else {//新增
            url = "dmc/rfidLabelRole/add";
            if (this.pid != "") {
              params.pid = this.pid;
            } else {
              params.pid = 0;
            }
          }
          console.log(params);
          this.dataFormLoading = true; //确定按钮loadin为true;
          this.$postJson(url, params).then(
            res => {
              console.log(res);
              if (res.code == 200) {
                this.$message({ message: res.message, type: "success" });
              } else {
                this.$message({ message: res.message, type: "error" });
              }
              this.operation = true; //重置状态为true
              this.dataFormLoading = false; //loading隐藏
              this.dialogVisibleForm = false; //dialog模态框关闭
              this.getTree(); //刷新字典树
              this.$refs.dataForm.resetFields(); //移除校验结果并重置字段值
            }
          );
          setTimeout(() => {
            this.operation = true; //重置状态为true
            this.dataFormLoading = false; //loading隐藏
            this.dialogVisibleForm = false; //dialog模态框关闭
            this.$refs.dataForm.resetFields(); //移除校验结果并重置字段值
          }, 1000)
        }
      });
    },

    /* 
      删除门禁卡角色 弹出dialog模态框
    */
    removeRole(node, data) {
      console.log(node, data);
      console.log(node, data);
      this.$confirm("确认是否删除门禁卡角色吗？", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        closeOnClickModal: false,
      })
        .then(() => {
          this.$postForm("dmc/rfidLabelRole/deleteById/" + data.id).then(
            res => {
              console.log(res);
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.message
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message
                });
              }
              this.getTree(); //刷新全局门禁卡角色树
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    /* 
      查询全局门禁角色
    */
    getTree() {
      this.treeList = [];
      this.list = [];
      this.$postForm("dmc/rfidLabelRole/queryAll").then(res => {
        console.log(res, "查询树");
        if (res.code == 200) {
          if (res.result.length > 0) {
            res.result.forEach((item, index) => {
              console.log(item);
              if (index == 0) {
                this.id = item.id;
                this.list.push({ id: item.id, title: item.roleName, text: item.remark });
                this.queryListWithPage();
              }
            });
            this.treeList = res.result;
            console.log(this.treeList, "全局门禁角色的数组");
          }
        }
      });
    },

    /* 
      查询门禁卡角色列表
    */
    queryListWithPage() {
      this.tableData = [];
      let params = new Object();
      params.pageNum = this.pageNum;
      params.pageSize = this.pageSize;
      params.roleId = this.id;
      console.log(params);
      this.$postJson("dmc/rfidLabel/queryGroupRfidLabelListWithPage", params).then(res => {
        console.log(res);
        if (res.code == 200) {
          if (res.result.list != null) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.totalDataNumber = res.result.total * 1;
            this.tableData = res.result.list;
          } else {
            this.tableData = [];
            this.pageSize = 10;
            this.currentPage = 1;
            this.totalDataNumber = 0;
          }
        } else {
          this.tableData = [];
          this.pageSize = 10;
          this.currentPage = 1;
          this.totalDataNumber = 0;
        }
      });
    },

    /* 
      初始页currentPage、初始每页数据数pagesize和数据data
    */
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数 
      this.PageSize = val;
      this.queryListWithPage();
    },

    /* 
      当前页变化
    */
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.queryListWithPage();
    },

    /* 
      修改表格的头部颜色
    */
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#bee1f4;color:#6f7075;font-weight: 700;height:50px;";
      }
    },

    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'background-color: #efefef'
      } else {
        return 'background-color: #f9f9f9'
      }
    },
  },
  created() { },
  mounted() {
    this.getTree();
  }
};
</script>
<style lang="scss" scoped>
.dictionary {
  width: 100%;
  //height: 100%;
  min-height: 600px;
  // margin-top:20px;
  background: #fefefe;

  .dictionary-left {
    float: left;
    width: 22%;
    // height: 100%;
    min-height: 600px;
    border: 1px #f1eff2 solid;
    margin-right: 0.5%;
    box-sizing: border-box;
  }

  .dictionary-right {
    float: right;
    width: 77%;
    height: 100%;
    margin-right: 0.5%;
    box-sizing: border-box;
  }

  .dictionary-row {
    height: 54px;
    line-height: 54px;
    background: #BDE0F3;
  }

  .dictionary-row-span-ml {
    height: 54px;
    line-height: 54px;
    margin-left: 10px;
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }

  .vertical-align-cursor {
    vertical-align: middle;
    cursor: pointer;
    width: 15px;
    height: 15px;
  }

  .imgSize {
    vertical-align: middle;
    cursor: pointer;
    width: 20px;
    height: 20px;
  }

  .height60 {
    height: 60px;
    line-height: 60px;
  }
}
</style>

